// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import Vuelidate from 'vuelidate'
import firebase from 'firebase'

import App from './App'
import router from './router'
import store from './store'

import { firebaseConfig } from './config/configFirebase'
firebase.initializeApp(firebaseConfig)

Vue.config.productionTip = false

Vue.use(VueLodash, lodash)

Vue.use(Vuetify, {
  theme: {
    primary: '#FA7070',
    secondary: '#4595C7',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
})
Vue.use(Vuelidate)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  store
})

export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./src/main.js